
import axios from 'axios'
import {axios as instance} from 'helpers/axios'

const AxiosMixin = {

  beforeCreate() {
    this.axios = instance
    this.axiosCancelTokenSource = axios.CancelToken.source()
  },

  beforeDestroy() {
    if(this.axiosCancelTokenSource != null) {
      this.axiosCancelTokenSource.cancel()
    }
  },
}

export default AxiosMixin
